var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"heatmap","height":"350","options":_vm.apexChatData.heatMapChart.chartOptions,"series":_vm.apexChatData.heatMapChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }